
import { defineComponent, ref } from 'vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { services } from '@/services/services'
import LoadingButton from '@/views/components/LoadingButton.vue'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'
import { download, isBlob } from '@/views/utils'
import { useStore } from 'vuex'
import { hasMessage, isAxiosError } from '@/repositories/errorHandler'
import { apiErrorMessage } from '@/apiErrorMessage'

const service = services.fuzoku

export default defineComponent({
  components: {
    DismissibleAlert,
    LoadingButton,
    ContentLayout
  },
  setup () {
    const errorMessage = ref<string | null>(null)
    const loading = ref(false)
    const store = useStore()

    const onClickedExport = async () => {
      loading.value = true
      const start = store.state.accountingStartDate
      const end = store.state.accountingEndDate
      try {
        const response = await service.exportJunsoku(start, end)
        download(response)
      } catch (e) {
        if (isAxiosError(e)) {
          if (e.response && e.response.status >= 400 && e.response.headers['content-type'] === 'application/json') {
            if (isBlob(e.response.data)) {
              const json = await e.response.data.text()
              const jsonObj = JSON.parse(json)
              if (hasMessage(jsonObj)) {
                errorMessage.value = jsonObj.message
              }
            }
          }
        }
        if (errorMessage.value === null) {
          errorMessage.value = apiErrorMessage.badRequest
        }
      } finally {
        loading.value = false
      }
    }

    return {
      onClickedExport,
      loading,
      errorMessage
    }
  }
})
